import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, AlertTriangle, Sunrise, Activity, Moon, Trophy } from 'lucide-react';
const chapters = [{
  icon: BookOpen,
  title: 'Comprende la verdadera causa del problema',
  description: 'Descubre cómo el estrés y el cortisol afectan tu sueño, energía, peso y bienestar.'
}, {
  icon: AlertTriangle,
  title: 'Identifica los hábitos que mantienen elevado tu cortisol',
  description: 'Aprende qué conductas diarias están saboteando tu recuperación sin que lo notes.'
}, {
  icon: Sunrise,
  title: 'Comienza el plan de reinicio de 21 días',
  description: 'Implementa acciones simples para reducir el impacto del estrés desde la primera semana.'
}, {
  icon: Activity,
  title: 'Recupera tu energía y descanso',
  description: 'Incorpora hábitos prácticos para dormir mejor, sentirte con más vitalidad y reducir el agotamiento.'
}, {
  icon: Moon,
  title: 'Consolida un estilo de vida saludable',
  description: 'Aprende a mantener los resultados con rutinas fáciles de seguir.'
}, {
  icon: Trophy,
  title: 'Plan de mantenimiento a largo plazo',
  description: 'Evita volver a los mismos hábitos y protege tu bienestar con estrategias sostenibles.'
}];
export const WhatsInsideSection: React.FC = () => {
  return <section className="py-20 lg:py-28 bg-brand-cream" data-id="element-166">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
        <motion.div className="text-center max-w-3xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-168">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal" data-id="element-169">
            Todo lo que necesitas para recuperar tu bienestar, paso a paso.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-170">
          {chapters.map((chapter, index) => {
          const Icon = chapter.icon;
          return <motion.div key={index} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border border-gray-100" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} data-id="element-171">
                <div className="w-12 h-12 bg-brand-lightmint rounded-xl flex items-center justify-center mb-6" data-id="element-172">
                  <Icon className="w-6 h-6 text-brand-emerald" data-id="element-173" />
                </div>
                <h3 className="text-xl font-bold text-brand-charcoal mb-3" data-id="element-174">
                  {chapter.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-175">
                  {chapter.description}
                </p>
              </motion.div>;
        })}
        </div>

        <div className="text-center mt-16" data-id="element-176">
          <a href="#pricing" className="inline-block px-8 py-4 text-lg font-bold text-white bg-brand-emerald hover:bg-brand-emeraldHover rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 text-center" data-id="element-177">
            QUIERO EMPEZAR MI TRANSFORMACIÓN — $9.99
          </a>
        </div>
      </div>
    </section>;
};